const systemGetters = {
  getRoles: (state) => state.roles,
  getRole: (state) => state.role,
  getPermissionsForSelect: (state) => state.permissionsSelect,
  getPermissions: (state) => state.permissions,
  getFilter: (state) => state.filter,
  getApps: (state) => state.apps,
  getCampaigns: (state) => state.campaigns,
  getCampaignTypes: (state) => state.campaignTypes,
  getCampaign: (state) => state.campaign,
  getSetting: (state) => state.setting,
  getStats: (state) => state.stats,
  getChecks: (state) => state.checks,
  getConnections: (state) => state.connections,
  getWholesalerManagements: (state) => state.wholesalerManagements,
  getDefaultBanners: (state) => state.defaultBanners,
  getPointSettings: (state) => state.pointSettings,
  getShopLimits: (state) => state.shopLimits,
  getBonusGoals: (state) => state.bonusGoals,
  getFeaturedProducts: (state) => state.featured_products,
  getVoucherSelect: (state) => state.voucherSelect,
  getVouchers: (state) => state.vouchers,
  getMainBoxes: (state) => state.mainBoxes,
  getMainBox: (state) => state.mainBox,
  getPromotions: (state) => state.promotionList,
  getPromotion: (state) => state.promotion
}

export { systemGetters }
